<script> 
	import { 
		headerTitleHome, 
		linkAV, 
		linkAVConheca, 
		linkPesquisaVendas,
		linkPesquisaLocacao,
		textSite,
		linkInstagram,
	} from '../store.js';
	
	import { link }         from "svelte-routing";
	import Vitrine          from '../components/Vitrine.svelte'
	import Busca            from '../components/Busca.svelte'
	import ListaImoveis     from '../components/ListaImoveis.svelte'
	import Boleto           from '../components/Boleto.svelte'
	import Instagram		from '../components/Instagram.svelte'
	import PopUp			from '../components/PopUp.svelte'

	let vitrines = [
		{
			image: 'vitrineVermelho.jpg', 
			imageMobile: 'vitrineVermelhoM.jpg', 
			title: 'Imóvel',
			href: '/imovel/Venda/YA3676/imovel-Apartamento-em-JARDIM-EUROPA-PORTO-ALEGRE-Cod-YA3676'
		},
		{
			image: 'vitrineBranco.jpg', 
			imageMobile: 'vitrineBrancoM.jpg', 
			title: 'Imóvel',
			href: '/imovel/Venda/YA4014/imovel-Apartamento-em-Bela-Vista-Porto-Alegre-Cod-YA4014'
		},
		{
			image: 'vitrinePiscina.jpg', 
			imageMobile: 'vitrinePiscinaM.jpg', 
			title: 'Imóvel',
			href: '/imovel/Venda/YA4014/imovel-Apartamento-em-Bela-Vista-Porto-Alegre-Cod-YA4014'
		},
		{
			image: 'vitrineLaudos.jpg', 
			imageMobile: 'vitrineLaudosM.jpg', 
			title: 'Laudos',
			href: '/laudos'
		},
		{
			image: 'vitrineBolsaImoveis.jpg', 
			imageMobile: 'vitrineBolsaImoveisM.jpg', 
			title: 'Bolsa de Imóveis e Oportunidades',
			target: '_blank',
			href: 'https://www.instagram.com/imobiliariayara/'
		},
		{
			image: 'vitrineCredpago.jpg', 
			imageMobile: 'vitrineCredpagoM.jpg', 
			title: 'Credpago',
			href: '/garantias-locaticias'
		},
		{
			image: 'vitrineIndicacaoPremiada.jpg', 
			imageMobile: 'vitrineIndicacaoPremiadaM.jpg', 
			title: 'Indicação Premiada',
			href: '/indique'
		},
	];

	let vitrinesBanner = [
		{
			image: 'vitrineClientes.jpg', 
			imageMobile: 'vitrineClientesM.jpg', 
			title: 'Promoção para Clientes',
			href: '/contato#assunto=Solicito%20detalhes%20sobre%20Promoção%20para%20Clientes%20-%20Indicação%20de%20Imóvel%20para%20locação'
		},
	];

	let vitrinesBanner2 = [
		{
			image: '2G2.jpg', 
			imageMobile: '2G2M.jpg', 
			title: '2G',
			href: 'mailto:2gmanutencaopredial@gmail.com'
		},
	];

	/* Imóveis */ 
	function search(e) {
		const url = '/imoveis/' + (e.tipo_negociacao == '-2'?'vendas':'locacao') + '#' + Object.entries(e.detail).filter(p=>p[1].length>0).flatMap(p=>`${p[0]}=${encodeURI(p[1])}`).join('&');
		document.location = url;
	}
	
	let filtrosDestaquesVendas  = {nt:-2, tipo_negociacao:-2, cidade:'', pageSize:6, random: 1, destaque: true};
	let filtrosDestaquesLocacao = {nt:-3, tipo_negociacao:-3, cidade:'', pageSize:6, random: 1, destaque: true};

	function activateSlickVendas() {
		activateSlick('.destaques-home--vendas');
	}
	function activateSlickLocacao() {
		activateSlick('.destaques-home--locacao');
	}
	function activateSlick(selector) {
		window.setTimeout(() => {
			let max = jQuery(selector + ' .row > div').length >= 3 ? 3 : (jQuery(selector + ' .row > div').length == 2 ? 2 : 1);
			let mid = jQuery(selector + ' .row > div').length >= 2 ? 2 : 1;
			let min = 1;
			jQuery(selector).show();
			jQuery(selector + ' .row').slick({
				infinite: true,
				speed: 400,
				slidesToShow: max,
				autoplay: true,
				arrows: false,
				dots: true,
				responsive: [
					{
						breakpoint: 850,
						settings: {
							slidesToShow: mid,
							slidesToScroll: mid,
							dots: true,
						}
					},
					{
						breakpoint: 500,
						settings: {
							slidesToShow: min,
							slidesToScroll: min,
							dots: true,
						}
					}
				]            
			});
		}, 500);
	}    
</script>

<svelte:head>
	<title>{$headerTitleHome}</title>
</svelte:head>

<h1 class="text-seo">{$headerTitleHome}</h1>

<Vitrine vitrines={vitrines} vitrineHeight="350px"/>

<section class="busca">
	<div class="container">
		<Busca on:filter={search} /> 
	</div>
</section>

<!-- Destaques Locação -->
<section style="display: none;" class="section destaques-home destaques-home--locacao mb-50">
	<div class="container">
		<div class="header">
			<h2 class="title color-primary"><b>Destaques para alugar</b></h2>
			<a class="link icon-transform" href="{$linkPesquisaLocacao}" title="Ofertas para alugar - {$textSite}">
				<i class="fas fa-plus-circle color-primary"></i> <b>Ofertas para alugar</b>
			</a>                
		</div>
		<ListaImoveis filters={filtrosDestaquesLocacao} showPaginator={false} afterLoadRealties={activateSlickLocacao} />
	</div>
</section>  

<section classe="section section-promo bg-destaque mt-50">
	<Vitrine vitrines={vitrinesBanner} showDots={false} vitrineHeight="350px"/>
</section>

<section class="section section-adm-condominios bg-destaque mt-50 hide">
	<div class="container">
		<div class="itens row align-items-center justify-content-center">
			<div class="item item--content col-12 col-md-6 mr-auto">
				<h2 class="title no-breakline--xs">
					Administração de condomínios <br> experiente e segura
				</h2>
				<p class="mb-30 mt-30">Conte com a {$textSite} para cuidar do seu condomínio com toda a segurança, eficiência e agilidade que você procura.</p>
				<div class="buttons">
					<a href="/administracao-condominios" use:link class="hover-transform btn btn-secondary mb-5" title="Clique aqui e confira os benefícios">Confira os benefícios</a>
					<a href="/solicite-proposta" use:link replace class="hover-transform btn btn-primary mb-5" title="Clique aqui e solicite uma proposta">Solicite uma proposta</a>
				</div>
			</div>
		</div>
	</div>
</section>

<!-- Destaques Vendas -->
<section style="display: none;" class="section destaques-home destaques-home--vendas mb-50">
	<div class="container">
		<div class="header mt-10">
			<h2 class="title color-primary"><b>Destaques para Comprar</b></h2>
			<a class="link icon-transform" href="{$linkPesquisaVendas}" title="Ir para Ofertas para comprar - {$textSite}">
				<i class="fas fa-plus-circle color-primary"></i> <b>Ofertas para comprar</b>
			</a>
		</div>
		<ListaImoveis filters={filtrosDestaquesVendas} showPaginator={false} afterLoadRealties={activateSlickVendas} />
	</div>
</section> 

<section classe="section section-promo bg-destaque mt-50">
	<Vitrine vitrines={vitrinesBanner2} showDots={false} vitrineHeight="350px"/>
</section>

<section class="section section-captacao mb-50">
	<div class="container">
		<div class="grid grid-size--1 grid-size-sm--2 grid-gap-30">
			<div class="card-border">
				<i class="fa-3x fas fa-bullhorn color-primary mb-20"></i>
				<h2 class="title">Anuncie seu imóvel</h2>
				<p class="mt-10 mb-15 no-breakline--xs">Para venda ou locação, anuncie seu imóvel com a <br> gente, nós cuidamos de tudo para você.</p>
				<a href="anuncie" use:link replace class="hover-transform btn btn-primary" title="Clique aqui para cadastrar seu imóvel">Anuncie aqui</a>
			</div>
			<div class="card-border">
				<i class="fa-3x fas fa-home color-primary mb-20"></i>
				<h2 class="title">Solicite um imóvel</h2>
				<p class="mt-10 mb-15 no-breakline--xs">Descreva o imóvel que você procura e nós <br> avisaremos quando encontrarmos.</p>
				<a href="solicite-imovel" use:link replace class="hover-transform btn btn-primary" title="Clique aqui para solicitar imóvel">Solicitar aqui</a>
			</div>
		</div>
	</div>
</section>

<section class="section section-aplicativo bg-destaque mt-10">
	<div class="container">
		<div class="itens row align-items-center justify-content-center">
			<div class="item col-12 col-sm-6 col-md-7 d-flex justify-content-md-end justify-content-center">
				<img class="img-fluid" src="assets/images/mockup.png" alt="Mockup {$textSite}" width="450">
			</div>            
			<div class="item item--content col-12 col-sm-6 col-md-5">
				<h2 class="title color-primary">
					Aplicativo <br> {$textSite}
				</h2>
				<p class="no-breakline--xs color-destaque mt-10 mb-10">Todos os serviços em um único lugar. <br> Utilize no tablet, celular ou computador. <br> Comunicação rápida, prática e segura.</p>
				<div class="buttons">
					<a href={$linkAVConheca} target="_blank" class="hover-transform btn btn-secondary" title="Saiba mais {$textSite}">Saiba mais</a>
					<a href={$linkAV} target="_blank" class="hover-transform btn btn-primary" title="Acesse o {$textSite}">Acesse agora</a>
				</div>
			</div>
		</div>
	</div>
</section>

<section class="section section-social">
	<div class="container">
		<div class="header mt-10 mb-30">
			<h2 class="title text-center">
				Siga <a href="{$linkInstagram}" target="_blank" class="color-primary">@imobiliariayara</a> nas redes sociais
			</h2>
		</div>
	</div>
	<Instagram />
</section>

<Boleto />
<PopUp channel="site" />